<template>
  <el-dialog
    :visible="showLogin"
    :before-close="close"
    :close-on-click-modal="false"
    class="login-dialog"
    title=""
    size="tiny"
  >
    <div class="login-content">
      <img src="../../../assets/img/登录页logo.png">
      <h1 class="login-top-title">会员登录</h1>
      <el-form
        ref="loginForm"
        :model="loginData"
        :rules="rules"
      >
        <el-form-item
          label="用户名/邮箱"
          prop="user"
        >
          <el-input
            v-model="loginData.user"
            placeholder="输入用户名/邮箱"
            auto-complete
          />
        </el-form-item>
        <el-form-item
          label="密码"
          prop="code"
        >
          <el-input
            v-model="loginData.code"
            placeholder="输入密码"
            type="password"
            @keyup.enter.native="login"
          />
        </el-form-item>
      </el-form>
      <el-button
        class="login-forget-code"
        type="text"
        @click="turnToForgetPassword"
      >忘记密码？</el-button>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        :disabled="clickBtn"
        type="primary"
        @click="login"
      >登 录</el-button>
      <div class="login-to-reg">
        <label>没有账号？</label>
        <el-button
          class="login-reg-btn"
          type="text"
          @click="turnToReg"
        >立即注册</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script type="text/ecmascript-6">
import {mapState, mapMutations, mapActions} from 'vuex'
import {formValidate} from '@/service/formValidate'
export default {
  components: {},
  props: {
    displayMark: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      loginData: {},
      clickBtn: false,
      dialogFormVisible: false,
      rules: {
        user: [
          {
            required: true, message: '请输入用户名或邮箱', trigger: 'blur'
          }
        ],
        code: [
          {
            validator: formValidate.validatePwd, trigger: 'change', required: true
          }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      showLogin: 'showLogin',
      isLogin: 'isLogin'
    })
  },
  methods: {
    ...mapMutations({
      close: 'LOGIN_CLOSE',
      showReg: 'REGISTER_SHOW'
    }),
    ...mapActions({
      userLogin: 'userLogin',
      getUserInfo: 'getHistoryInfo'
    }),
    login () {
      this.$refs.loginForm.validate((valid) => {
        if (!valid) {
          return false
        }
        let postData = {
          username: this.loginData.user,
          password: this.loginData.code
        }
        this.clickBtn = true
        this.userLogin(postData).then(() => {
          this.clickBtn = false
          if (this.isLogin) {
            this.close()
            this.getUserInfo()
          }
        })
      })
    },
    turnToReg () {
      this.close()
      this.showReg()
    },
    turnToForgetPassword () {
      const {href} = this.$router.resolve({
        path: '/resetPassword/1'
      })
      // let href = location.href + '/resetPassword/1'
      // console.log(location)
      window.open(href)
      this.close()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/common/user-out/login-dialog.vue